<app-neojobz-header></app-neojobz-header>
<!-- <div class="header-main ">
    <div class="container">
        <nav class="navbar navbar-new navbar-expand-lg navbar-light bg-white shadow">
            <a class="navbar-brand" href="#"> -->
                <!-- <img src="https://whiterobecdns.com/wr-logos/r2_o.svg" width="200" alt=""> -->
                 <!-- <img src="/assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt=""> -->
                 <!-- <img src="/assets/images/NeoJobz_Brandname_1.svg" width="200" height="50" alt=""> -->
            <!-- </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav m-auto">
                    <li class="nav-item">
                        <a class="nav-link" (click)="goTo('/')" style="cursor: pointer;" [ngClass]="{'active-link': activePath === '/'}">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" (click)="goTo('/about-us')" style="cursor: pointer;" [ngClass]="{'active-link': activePath === '/about-us'}">About</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" (click)="goTo('/our-services')" style="cursor: pointer;"  [ngClass]="{'active-link': activePath === '/our-services'}">Services</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" (click)="goTo('/products')" style="cursor: pointer;"  [ngClass]="{'active-link': activePath === '/products'}">Pricing</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" (click)="goTo('/contact-us')" style="cursor: pointer;"  [ngClass]="{'active-link': activePath === '/contact-us'}">Contact</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" href="https://blog.whiterobe.in/" target="_blank">Blog</a>
                    </li>

                </ul>
                 
                <span>
                    <ul style="margin-top: 2%;">
                        <li>
                            <button class="secondary-btn-round me-3 mt-1" (click)="goTo('/demo')">Request A Demo</button>
                        </li>
                        <li> -->
                            <!-- <button  (click)="goToFreePlan(freePlan)" class="contact-btn">
                                Post A Free Job
                                <span class="arr-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                                        class="bi bi-arrow-up-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
                                    </svg>
                                </span>
                            </button> -->
                            <!-- <button  (click)="goToFreePlan(freePlan)" class="primary-btn-round">
                                Post A Free Job
                                <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                </span>
                            </button>
                        </li>
                    </ul>
                   
                    <span *ngIf="!isLoggedIn" class="float-autp sign-up_btns">
                         <a (click)="goTo('/login')" class="me-3">Sign In</a> -->
                        <!-- <a (click)="goTo('/register')" class="me-3">Sign Up</a>
                        <span class="float-autp sign-up_btns">
                         <a (click)="goTo('/sign-in')" class="me-3">Sign In</a>
                        <a (click)="goTo('/sign-up')" class="me-3">Sign Up</a>
                    </span>
                    <span *ngIf="isLoggedIn" class="float-autp sign-up_btns">
                        <a (click)="goToDashboard()" class="me-3">Dashboard</a>
                        <a (click)="logout()" class="me-3">Logout</a>
                    </span>
                    
                </span>
            </div>
        </nav>
    </div>
</div> -->